import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfHttpService {

  // backend:string = 'http://localhost:8000/api/';
  backend:string='http://api.crabslogistica.ar/api/';
  constructor() { }

  getBackend():string{

    return this.backend;
  }


}
